export default "__VITE_ASSET__D$vBHAB5__"